import { Component } from './component.js';

export class Icon extends Component {
  static defaultOptions = {
    componentName: 'Icon',
    tagName: 'i',
    icon: 'smile'
  };

  constructor (options) {
    super($.extend({}, Icon.defaultOptions, options));
    this.setIcon(this.options.icon);
  }

  setIcon (icon) {
    if (!icon) return;
    this.el.attr('class', 'fa fa-' + icon);
  }
}
